import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress, useTheme } from '@mui/material';

const UserInfo = ({ authHeaders, backEnd }) => {
  const theme = useTheme();
  const [loading, setLoading] = useState(true);
  const [userInfodata, setUserInfodata] = useState({
    credits: '',
    predictionsnum: '',
    ownlistings: '',
  });

  useEffect(() => {
    const fetchUserDetails = async () => {
      console.log("Fetching user info..."); // Debugging Log

      if (!authHeaders) {
        console.error("Missing authHeaders!");
        return;
      }

      try {
        const response = await fetch(backEnd + 'user_info_data', {
          method: 'GET',
          headers: { Authorization: authHeaders },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user details');
        }

        const data = await response.json();
        console.log("User data fetched:", data);

        setUserInfodata({
          credits: data.credits || 'N/A',
          predictionsnum: data.predictionsnum || 'N/A',
          ownlistings: data.ownlistings || 'N/A',
        });
      } catch (error) {
        console.error('Error fetching user details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, [authHeaders, backEnd]);

  return (
    <div className='user-details'>
       <Typography variant="h5" gutterBottom sx={{ color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center'}}>
              Информация за профила
            </Typography>
    <Box sx={{ maxWidth: 600, margin: '0 auto', textAlign: 'left', padding: 2 }}>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <CircularProgress /> 
          <Typography variant="h6" color="textSecondary" sx={{ ml: 2 }}>
            Зареждане на данни...
          </Typography>
        </Box>
      ) : (
        <Box>
          <Typography variant="h6" sx={{ color: theme.palette.text.primary}}> Брой кредити: {userInfodata.credits}</Typography>
          <Typography variant="h6" sx={{ color: theme.palette.text.primary}}>Брой прогнози: {userInfodata.predictionsnum}</Typography>
          <Typography variant="h6" sx={{ color: theme.palette.text.primary}}>Брой лични обяви: {userInfodata.ownlistings}</Typography>
        </Box>
      )}
    </Box>
    </div>
  );
};

export default UserInfo;
